import gql from 'graphql-tag';

export const assignTraining = gql`
  mutation AssignTraining(
    $assignees: [UserInput!]!
    $assignment: AssignmentInput!
    $assignor: UserInput!
  ) {
    assignTraining(
      assignees: $assignees
      assignment: $assignment
      assignor: $assignor
    ) {
      success
    }
  }
`;
